/**
 * Valeria Monroy Silva (2548): mismos permisos de tickets que Paola (1312).
 * Ve, reasigna y contesta tickets de María Esther Segura (568)
 * y de Ángel López, jefe de mantenimiento (31).
 */
export const IDERP_VALERIA_MONROY = 2548

export function esJefeTickets (usuario) {
  if (!usuario) return false
  if (usuario.cargo === 'Jefe') return true
  return Number(usuario.iderp) === IDERP_VALERIA_MONROY
}

/**
 * Ven en Tickets asignados los tickets de alumnos, teachers, recepción, encargadas, ventas,
 * coordinador académico, programador de producto y mantenimiento (solo ver y comentar).
 * 568 además ve, responde y reasigna los tickets que sube el personal de Operaciones.
 */
export const IDERPS_TICKETS_VISOR_PUESTOS = [568, 1312, 3219]

export function esVisorTicketsPuestos (usuario) {
  if (!usuario) return false
  return IDERPS_TICKETS_VISOR_PUESTOS.includes(Number(usuario.iderp))
}
